import { types } from "../action-types";

const initialState = {
    loading: false,
    follow_success: false,
    unfollow_success: false,
};

const followUnFollowReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_FOLLOW_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.POST_FOLLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                follow_success: true,
                unfollow_success: false,
            };
        case types.POST_FOLLOW_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case types.POST_UNFOLLOW_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.POST_UNFOLLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                follow_success: false,
                unfollow_success: true,
            };
        case types.POST_UNFOLLOW_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;

    }
};

export default followUnFollowReducer;
